module.exports = __webpack_public_path__ + "static/media/campo2.8f4118fa.jpg";